import Searchbox from '@admin/components/searchbox'
import Infinite from '@admin/components/infinite'
import PropTypes from 'prop-types'
import pluralize from 'pluralize'
import Results from './results'
import React from 'react'

class List extends React.Component {

  static propTypes = {
    contact: PropTypes.object,
    defaultQuery: PropTypes.object,
    email: PropTypes.object,
    email_campaign: PropTypes.object,
    endpoint: PropTypes.string,
    order: PropTypes.object,
    perspective: PropTypes.string,
    program: PropTypes.object,
    provider: PropTypes.object,
    refresh: PropTypes.string,
    registration: PropTypes.object,
    response: PropTypes.object,
    selected: PropTypes.object,
    show_interactions: PropTypes.bool,
    show_outcome: PropTypes.bool,
    subscription: PropTypes.object,
    usage: PropTypes.object,
    user: PropTypes.object,
    onChoose: PropTypes.func
  }

  state = {
    q: ''
  }

  _handleType = this._handleType.bind(this)

  render() {
    return (
      <div className="email-reader-list">
        <Searchbox { ...this._getSearchbox() } />
        <Infinite { ...this._getInfinite() } />
      </div>
    )
  }

  _getInfinite() {
    const { contact, defaultQuery, email, email_campaign, endpoint, program, provider, refresh, response, subscription, selected, show_interactions, show_outcome, usage, user, onChoose } = this.props
    const perspective = this._getPerspective()
    const { q } = this.state
    return {
      endpoint,
      ...refresh ? { refresh } : {},
      query: {
        ...defaultQuery || {},
        ...usage ? { usage_id: usage.id } : {},
        ...email ? { email_id: email.id } : {},
        ...email_campaign ? { email_campaign_id: email_campaign.id } : {},
        ...contact ? { contact_id: contact.id } : {},
        ...program ? { program_id: program.id } : {},
        ...provider ? { provider_id: provider.id } : {},        
        ...response ? { response_id: response.id } : {},
        ...subscription ? { subscription_id: subscription.id } : {},
        ...user ? { user_id: user.id } : {}
      },
      filter: {
        $and: [
          { sent_at: { $nnl: true }}
        ],
        ...q.length > 0 ? { q } : {}
      },
      sort: {
        key: 'sent_at',
        order: 'desc'
      },
      footer: ({ all, total }) => `Showing ${total} of ${pluralize('email', all, true)}`,
      layout: Results,
      props: {
        perspective,
        selected,
        show_interactions,
        show_outcome,
        onChoose
      }
    }
  }

  _getPerspective() {
    const { contact, email_campaign, order, perspective, program, provider, registration, response, subscription, usage, user } = this.props
    if(perspective) return perspective
    if(email_campaign) return 'program'
    if(subscription) return 'program'
    if(registration) return 'program'
    if(response) return 'program'
    if(program) return 'program'
    if(provider) return 'program'
    if(contact) return 'contact'
    if(usage) return 'contact'
    if(order) return 'program'
    if(user) return 'user'
  }

  _getSearchbox() {
    return {
      prompt: 'Search',
      onChange: this._handleType
    }
  }

  _handleType(q) {
    this.setState({ q })
  }

}

export default List
